import React from "react";
import "./consult-info-style.css";

export const FILTER_KEYS_NAME_REPLACEMENT = {
  CCP1: "Quantidade de Parcelas",
  CC1: "Valor no Cartão de Crédito",
  CCA1: "Código de Autorização",
  CCP2: "Quantidade de Parcelas 2",
  CC2: "Valor no Cartão de Crédito 2",
  CCA2: "Código de Autorização 2",
  lastModificationDate: "Data da Última Modificação",
  COND: "Condição de Pagamento",
  cpf: "CPF",
  id: "ID do Pacote",
  TR_DATE: "Data da Transação",
  ENTRY: "Valor de Entrada",
  creationDate: "Data de Criação",
  DISCOUNT: "Desconto",
  phone: "Telefone",
  imei: "IMEI",
  username: "Usuário",
  status: "Status",
  Operation: "Operação",
  superStore: "Master Varejo",
  store: "Loja",
  "CED-CPF": "CPF do Cedente",
  MSISDN: "MSISDN",
  DDD: "DDD",
  statusDescription: "Descrição do Status",
  NAME: "Nome",
  BIRTHDATE: "Data de Nascimento",
  SESSIONID: "SessionID",
  "LIVE-PLANO": "Plano Live",
  "VOIP1-PLANO": "Plano VOIP 1",
  "VOIP2-PLANO": "Plano VOIP 2",
  "LIVE-PROTOCOLO": "Protocolo Live",
  PARCEIRO: "Parceiro",
  CPFCNPJ: "CNPJ",
  CNPJ: "CNPJ",
  PDV: "PDV",
  "SOCIO-DOC": "Documento Sócio",
};

export const FILTER_KEYS_NAME_REPLACEMENT_FULL_DETAILS_TAB = {
  "A2-REC-MSG-N": "A2-REC-MSG-N",
  "A2-REC-MSG-S": "A2-REC-MSG-S",
  "A3-REC-MSG-N": "A3-REC-MSG-N",
  "A3-REC-MSG-S": "A3-REC-MSG-S",
  ACESSORIO: "Acessorio",
  AGENCIA: "Agencia",
  "ANO-ATUAL": "Ano atual",
  APARELHO: "Aparelho",
  "APARELHO-DESCONTO": "Aparelho desconto",
  "APARELHO-IMEI": "Aparelho Imei",
  "APARELHO-MULTA": "Aparelho multa",
  "APARELHO-VALOR-INICIAL" : "Aparelho valor inicial",
  "AT-END": "At end",
  "ATV-SVR-ADC": "ATV-SVR-ADC",
  "AUT-DEB-AUT": "AUT-DEB-AUT",
  BAIRRO: "Bairro",
  "BAIRRO-INSTALACAO": "Bairro instalacao",
  "BENEFICIOS-APP": "BENEFICIOS-APP",
  BIRTHDATE: "Data de Nascimento",
  "CED-CPF": "CED-CPF",
  "CED-NOME": "CED-NOME",
  CEP: "CEP",
  CLIENTID: "CLIENTID",
  "CEP-INSTALACAO": "CEP-INSTALACAO",
  "CF_3MESES": "CF_3MESES",
  CIDADE: "Cidade",
  "CIDADE-INSTALACAO": "CIDADE-INSTALACAO",
  CNPJ: "CNPJ",
  "COD-ACESSO": "COD-ACCESO",
  "COD-ACESSO-TIT-DEP":"COD-ACESSO-TIT-DEP",
  "COD-COM-PLANO":"COD-COM-PLANO",
  "COD-LOJA":"COD-LOJA",
  "COD-NOVO-PLANO":"COD-NOVO-PLANO",
  "COD-NOVO-PLANO-VOIP1":"COD-NOVO-PLANO-VOIP1",
  "COD-NOVO-PLANO-VOIP2":"COD-NOVO-PLANO-VOIP2",
  COMPLEMENTO:"COMPLEMENTO",
  "COMPLEMENTO-INSTALACAO":"COMPLEMENTO-INSTALACAO",
  "CONT-WHATS":"CONT-WHATS",
  "CONTATO-DOC":"CONTATO-DOC",
  "CONTATO-TEL":"CONTATO-TEL",
  "CONTRATO-EMAIL":"CONTRATO-EMAIL",
  cpf: "CPF",
  creationDate: "Data de Criação",
  "CPF-REP-LEG":"CPF-REP-LEG",
  "CPF-USER": "CPF-USER",
  "CUSTCODE-PDV":"CUSTCODE-PDV",
  DADOS: "Dados",
  "DADOS-CONTATO": "Dados de contato",
  "DATA-NASCIMENTO": "Data de Nascimento",
  DDD: "DDD",
  "DDD-COD-ACESSO":"DDD-COD-ACESSO",
  "DDD-COD-ACESSO-TIT-DEP":"DDD-COD-ACESSO-TIT-DEP",
  "DDD-NUM-PORTADO":"DDD-NUM-PORTADO",
  "DDD-TEL-CONTATO": "DDD-TEL-CONTATO",
  "DDD-TEL-CONTATO-2":"DDD-TEL-CONTATO-2",
  "DDD-TEL-CONTATO-3":"DDD-TEL-CONTATO-3",
  "DDD-TEL-FIXO":"DDD-TEL-FIXO",
  "DESC-TAXA-HAB": "DESC-TAXA-HAB",
  "DIA-ATUAL": "DIA-ATUAL",
  "DIA-VENCIMENTO":"DIA-VENCIMENTO",
  DOCUMENTO: "DOCUMENTO",
  "DOCUMENTO-DT-EMISSAO":"DOCUMENTO-DT-EMISSAO",
  "DOCUMENTO-UF-EMISSAO":"DOCUMENTO-UF-EMISSAO",
  "DST-SVR":"DST-SVR",
  "DT-FUND-EMP":"DT-FUND-EMP",
  "DT-HR-AGEND":"DT-HR-AGEND",
  "DT-INIC-FIDEL":"DT-INIC-FIDEL",
  EMAIL: "EMAIL",
  "END-INSTALACAO": "Endereco instalacao",
  ENDERECO: "ENDERECO",
  "ENDERECO_CF": "ENDERECO_CF",
  "ENDERECO_INSTALL_CF":"ENDERECO_INSTALL_CF",
  "FAT-CET-DET":"FAT-CET-DET",
  "FAT-CET-RES":"FAT-CET-RES",
  "FAT-ONLINE":"FAT-ONLINE",
  "FLAG-ANALFABETO":"FLAG-ANALFABETO",
  "FLAG-NECES-ESPECIAL":"FLAG-NECES-ESPECIAL",
  "FLAG-SEGURO":"FLAG-SEGURO",
  "FLG-ALCADA":"FLG-ALCADA",
  "FLG-BIOMETRIA":"FLG-BIOMETRIA",
  "FLG-BLK-LIST":"FLG-BLK-LIST",
  "FLG-BOLETO":"FLG-BOLETO",
  "FLG-BYPASS-BIOMETRIA":"FLG-BYPASS-BIOMETRIA",
  "FLG-DEP":"FLG-DEP",
  "FLG-DOC-CEDENTE":"FLG-DOC-CEDENTE",
  "FLG-DOC-TEST1":"FLG-DOC-TEST1",
  "FLG-DOC-TEST2":"FLG-DOC-TEST2",
  "FLG-FEMININO":"FLG-FEMININO",
  "FLG-FIDEL":"FLG-FIDEL",
  "FLG-CONTAINSFACE": "FLG-CONTAINSFACE",
  "FLG-ALCADA":"FLG-ALCADA",
  "FLG-BIOMETRIA":"FLG-BIOMETRIA",
  "FLG-BLK-LIST":"FLG-BLK-LIST",
  "FLG-BOLETO":"FLG-BOLETO",
  "FLG-BYPASS-BIOMETRIA":"FLG-BYPASS-BIOMETRIA",
  "FLG-DEP":"FLG-DEP",
  "FLG-DOC-CEDENTE":"FLG-DOC-CEDENTE",
  "FLG-DOC-TEST1":"FLG-DOC-TEST1",
  "FLG-DOC-TEST2":"FLG-DOC-TEST2",
  "FLG-FEMININO":"FLG-FEMININO",
  "FLG-FIDEL":"FLG-FIDEL",
  "FLG-FIDELIZACAO-ACESSORIO":"FLG-FIDELIZACAO-ACESSORIO",
  "FLG-FIDELIZACAO-APARELHO":"FLG-FIDELIZACAO-APARELHO",
  "FLG-FIDELIZACAO-PLANO":"FLG-FIDELIZACAO-PLANO",
  "FLG-MASCULINO":"FLG-MASCULINO",
  "FLG-MESA-THALES":"FLG-MESA-THALES",
  "FLG-MESA-TIM":"FLG-MESA-TIM",
  "FLG-MULTI-ACESSO":"FLG-MULTI-ACESSO",
  "FLG-PF":"FLG-PF",
  "FLG-PJ":"FLG-PJ",
  "FLG-PORT-TEMP-MVL":"FLG-PORT-TEMP-MVL",
  "FLG-PORT-TEMP-VOIP1":"FLG-PORT-TEMP-VOIP1",
  "FLG-PORT-TEMP-VOIP2":"FLG-PORT-TEMP-VOIP2",
  "FLG-SCM":"FLG-SCM",
  "FLG-TAC":"FLG-TAC",
    id: "ID do Pacote",
  imei: "IMEI",
  "INSCRICAO-ESTADUAL":"INSCRICAO-ESTADUAL",
  "INSCRICAO-MUNICIPAL":"INSCRICAO-MUNICIPAL",
  "INSCRICAO-MUNICIPIO-EMISSAO":"INSCRICAO-MUNICIPIO-EMISSAO",
  INTERNET:"INTERNET",
  ISENTO:"ISENTO",
  LASTMODIFICATIONDATE:"LASTMODIFICATIONDATE",
  JORNADA:"JORNADA",
  "LIVE-DEGUSTACAO":"LIVE-DEGUSTACAO",
  "LIVE-DESCONTO":"LIVE-DESCONTO",
  "LIVE-DESCONTO-DACC":"LIVE-DESCONTO-DACC",
  "LIVE-FIDELIZACAO":"LIVE-FIDELIZACAO",
  "LIVE-FIDELIZACAO-DESC":"LIVE-FIDELIZACAO-DESC",
  "LIVE-PLANO":"LIVE-PLANO",
  "LIVE-PLANO-VALOR":"LIVE-PLANO-VALOR",
  "LIVE-PROTOCOLO":"LIVE-PROTOCOLO",
  "LIVE-SERVICOSADC":"LIVE-SERVICOSADC",
  "LIVE-TAXA-HAB":"LIVE-TAXA-HAB",
  "LIVE-VLSERVICOSADC":"LIVE-VLSERVICOSADC",
  LOCAL:"LOCAL",
  "LOCALDATA_CF":"LOCALDATA_CF",
  "MATRICULA-VENDEDOR":"MATRICULA-VENDEDOR",
  "MES-ATUAL":"MES-ATUAL",
  MINUTOS:"MINUTOS",
  MOTIVO:"MOTIVO",
  MSISDN:"MSISDN",
  "MSISDN_CF":"MSISDN_CF",
  "MSISDN-CONTATO":"MSISDN-CONTATO",
  "MSISDN-CONTATO-2":"MSISDN-CONTATO-2",
  "MSISDN-CONTATO-3":"MSISDN-CONTATO-3",
  "MSISDN-FIXO":"MSISDN-FIXO",
  "MSISDN-PORTADO":"MSISDN-PORTADO",
  "MSISDN-TIT-DEP":"MSISDN-TIT-DEP",
  "MUD-AREA-REG-D":"MUD-AREA-REG-D",
  "MUD-AREA-REG-M":"MUD-AREA-REG-M",
  "N-ACESSOS":"N-ACESSOS",
  "N-CONTRATO":"N-CONTRATO",
  NACIONALIDADE:"NACIONALIDADE",
  "NOME-BANCO":"NOME-BANCO",
  "NOME-CLIENTE":"NOME-CLIENTE",
  "NOME-DESC-TAXA-HAB":"NOME-DESC-TAXA-HAB",
  "NOME-MAE":"NOME-MAE",
  "NOME PARAMETRO":"NOME PARAMETRO",
  "NOME-TEST-1":"NOME-TEST-1",
  "NOME-TEST-2":"NOME-TEST-2",
  "NOVO-NUM-CONTRATO":"NOVO-NUM-CONTRATO",
  "NOVO-NUM-CONTRATO-NT":"NOVO-NUM-CONTRATO-NT",
  "NOVO-PLANO":"NOVO-PLANO",
  NRF:"NRF",
  "NUM-BANCO":"NUM-BANCO",
  "NUM-CC":"NUM-CC",
  "NUM-PORTADO":"NUM-PORTADO",
  NUMERO:"NUMERO",
  "NUMERO-INSTALACAO":"NUMERO-INSTALACAO",
  "OPER-BANCO":"OPER-BANCO",
  "OPER-DOADORA":"OPER-DOADORA",
  OPERACAO:"OPERACAO",
  "ORG-EXP":"ORG-EXP",
  ORIGEM:"ORIGEM",
  "PACOTE-COMPARTILHADO":"PACOTE-COMPARTILHADO",
  "PARC-TAXA-HAB":"PARC-TAXA-HAB",
  "PCT-H-M":"PCT-H-M",
  "PCT-H-M-2":"PCT-H-M-2",
  "PCT-H-M-3":"PCT-H-M-3",
  "PCT-H-M-4":"PCT-H-M-4",
  "PDV-NOME":"PDV-NOME",
  "PER-REST-FID":"PER-REST-FID",
  phone: "Telefone",
  "PLANO-DESCONTO-FIDELIZACAO":"PLANO-DESCONTO-FIDELIZACAO",
  "PLANO-PRAZO-PERM":"PLANO-PRAZO-PERM",
  "PLANO-VALOR-FINAL":"PLANO-VALOR-FINAL",
  "POS-VENDA":"POS-VENDA",
  PROCURADOR:"PROCURADOR",
  PROTOCOLO:"PROTOCOLO",
  "PROTOCOLO-PORT":"PROTOCOLO-PORT",
  "RAZAO-SOCIAL":"RAZAO-SOCIAL",
  "REC-MSG-N":"REC-MSG-N",
  "REC-MSG-S":"REC-MSG-S",
  "REFERENCIA-INSTALACAO":"REFERENCIA-INSTALACAO",
  "REP-LEG":"REP-LEG",
  "RG-TEST-1":"RG-TEST-1",
  "RG-TEST-2":"RG-TEST-2",
  roleId:"ROLEID",
  scenarioId:"SCENARIOID",
  "SEGMENTO-PLANO":"SEGMENTO-PLANO",
  SENHA:"SENHA",
  "SERIAL-DEVICE":"SERIAL-DEVICE",
  SMP:"SMP",
  SOCIO:"SOCIO",
  superStore: "Master Varejo",
  store: "Loja",
  "SOCIO-DOC":"SOCIO-DOC",
  "SPV-PROCURADOR":"SPV-PROCURADOR",
  "SPV-REP-LEG":"SPV-REP-LEG",
  status:"STATUS",
  statusDescription: "Descrição do Status",
  STFC:"STFC",
  "TEL-CONTATO":"TEL-CONTATO",
  "TEL-CONTATO-2":"TEL-CONTATO-2",
  "TEL-CONTATO-3":"TEL-CONTATO-3",
  "TEL-FIXO":"TEL-FIXO",
  "THALES_AUDIT_WF_TRAIL":"THALES_AUDIT_WF_TRAIL",
  TICKETID:"TICKETID",
  CONTRATO: "CONTRATO",
  "TICKET_TAGS":"TICKET_TAGS",
  "TIPO-DEF":"TIPO-DEF",
  "TIPO-SEGURO":"TIPO-SEGURO",
  "TMP-CONTR-PERM":"TMP-CONTR-PERM",
  "TMP-FID-ACESSORIO":"TMP-FID-ACESSORIO",
  "TP-FID-ULTRAFIBRA":"TP-FID-ULTRAFIBRA",
  TR_DATE: "Data da Transação",
  "TROCA-TIMCHIP-CORP":"TROCA-TIMCHIP-CORP",
  "TROCA-TIMCHIP-POS":"TROCA-TIMCHIP-POS",
  "TROCA-TIMCHIP-PRE":"TROCA-TIMCHIP-PRE",
  "TT-MOTIVO":"TT-MOTIVO",
  "TT-NANT-TC":"TT-NANT-TC",
  "TT-NNOVO-TC":"TT-NNOVO-TC",
  UF:"UF",
  "UF-INSCRICAO-ESTADUAL":"UF-INSCRICAO-ESTADUAL",
  "UF-INSCRICAO-MUNICIPAL":"UF-INSCRICAO-MUNICIPAL",
  "UF-INSTALACAO":"UF-INSTALACAO",
  username:"Usuário",
  "VAL-COM-FID-ACESSORIO":"VAL-COM-FID-ACESSORIO",
  "VAL-COM-FID-APARELHO":"VAL-COM-FID-APARELHO",
  "VAL-DESC-DACC":"VAL-DESC-DACC",
  "VAL-DESC-PLN":"VAL-DESC-PLN",
  "VAL-FRANQUIA-SEGURO":"VAL-FRANQUIA-SEGURO",
  "VAL-LIM-INDENIZACAO":"VAL-LIM-INDENIZACAO",
  "VAL-PREMIO-SEGURO":"VAL-PREMIO-SEGURO",
  "VAL-SEGURO":"VAL-SEGURO",
  "VAL-SEM-FID-ACESSORIO":"VAL-SEM-FID-ACESSORIO",
  "VAL-SEM-FID-APARELHO":"VAL-SEM-FID-APARELHO",
  "VAL-SVR-ADC":"VAL-SVR-ADC",
  "VAL-TOT-ADC":"VAL-TOT-ADC",
  "VAL-TOT-PAGAR":"VAL-TOT-PAGAR",
  "VALOR-PLANO":"VALOR-PLANO",
  VENDA:"VENDA",
  "VENDEDOR-NOME":"VENDEDOR-NOME",
  VERSAO:"VERSAO",
  "VND-APARELHO":"VND-APARELHO",
  "VOIP1-DESC":"VOIP1-DESC",
  "VOIP1-FIDELIZACAO":"VOIP1-FIDELIZACAO",
  "VOIP1-NUMERO":"VOIP1-NUMERO",
  "VOIP1-NUMEROPORT":"VOIP1-NUMEROPORT",
  "VOIP1-PLANO":"VOIP1-PLANO",
  "VOIP1-PROTOCOLO":"VOIP1-PROTOCOLO",
  "VOIP1-SERVICOSADC":"VOIP1-SERVICOSADC",
  "VOIP1-VALOR":"VOIP1-VALOR",
  "VOIP1-VLSERVICOSADC":"VOIP1-VLSERVICOSADC",
  "VOIP2-DESC":"VOIP2-DESC",
  "VOIP2-FIDELIZACAO":"VOIP2-FIDELIZACAO",
  "VOIP2-NUMERO":"VOIP2-NUMERO",
  "VOIP2-NUMEROPORT":"VOIP2-NUMEROPORT",
  "VOIP2-PLANO":"VOIP2-PLANO",
  "VOIP2-PROTOCOLO":"VOIP2-PROTOCOLO",
  "VOIP2-SERVICOSADC":"VOIP2-SERVICOSADC",
  "VOIP2-VALOR":"VOIP2-VALOR",
  "VOIP2-VLSERVICOSADC":"VOIP2-VLSERVICOSADC",
  FRONT: 'Canal de venda detalhado',
  IDCOMBO1: "IDCOMBO1",
  IDCOMBO2: "IDCOMBO2",
  IDCOMBO3: "IDCOMBO3",
  lastModificationDate: "Data da Última Modificação do Status",
  SUBCLIENTID: 'Subtipo de cliente',
  CADESTITLE: "Título do Termo de Adesão",
  CCP1: "Quantidade de Parcelas Cartão 1",
  CC1: "Valor no Cartão de Crédito 1",
  CCA1: "Código de Autorização Cartão 1",
  CCP2: "Quantidade de Parcelas Cartão 2",
  CC2: "Valor no Cartão de Crédito 2",
  CCA2: "Código de Autorização Cartão 2",
  COND: "Condição de Pagamento",
  CPERMTITLE: "Título do Termo de Permanência",
  DISCOUNT: "Desconto",
  ENTRY: "Valor de Entrada",
  "ACTIV-CODE": "ACTIV-CODE",
  "COD-MASTERVAREJO": "COD-MASTERVAREJO"
};

export const PREPAID_KEY_VALUE_REPLACEMENT = {
  id: "ID do Pacote",
  TR_DATE: "Data da Transação",
  SESSIONID: "SessionID",
  cpf: "CPF",
  NAME: "Nome",
  BIRTHDATE: "Data de Nascimento",
  status: "Status",
};

export const LIVETIM_KEY_VALUE_REPLACEMENT = {
  "LIVE-PLANO": "Plano Live",
  "VOIP1-PLANO": "Plano VOIP 1",
  "VOIP2-PLANO": "Plano VOIP 2",
  cpf: "CPF",
  CNPJ: "CNPJ",
  "SOCIO-DOC": "Documento Sócio",
  TR_DATE: "Data da Transação",
  lastModificationDate: "Data da Última Modificação do Status",
  creationDate: "Data de Criação",
  statusDescription: "Descrição do Status",
  id: "ID do Pacote",
  "LIVE-PROTOCOLO": "Protocolo Live",
  status: "Status",
  username: "Usuário",
  PARCEIRO: "Parceiro",
};

export const FILTER_KEYS_EXPORT_NAME_PLACEMENT = {
  CCP1: "Quantidade de Parcelas Cartão 1",
  CC1: "Valor no Cartão de Crédito 1",
  CCA1: "Código de Autorização Cartão 1",
  CCP2: "Quantidade de Parcelas Cartão 2",
  CC2: "Valor no Cartão de Crédito 2",
  CCA2: "Código de Autorização Cartão 2",
  lastModificationDate: "Data da Última Modificação do Status",
  COND: "Condição de Pagamento",
  cpf: "CPF",
  CPFCNPJ: "CNPJ",
  TR_DATE: "Data da Transação",
  ENTRY: "Valor de Entrada",
  creationDate: "Data de Criação",
  DISCOUNT: "Desconto",
  phone: "MSISDN",
  imei: "IMEI",
  username: "Usuário criador do pacote",
  status: "Status detalhado",
  Operation: "Operação",
  superStore: "ID Grupo Econômico",
  store: "Código da Loja",
  "CED-CPF": "CPF do Cedente",
  MSISDN: "MSISDN",
  DDD: "DDD",
  statusDescription: "Histórico de Alterações",
  id: 'ID do pacote',
  CLIENTID: 'Tipo de cliente',
  SUBCLIENTID: 'Subtipo de cliente',
  CONTRATO: 'Número do Contrato',
  'NOVO-PLANO': 'Nome do Plano',
  FRONT: 'Canal de venda detalhado',
};

export const FILTER_DOCUMENT_KEYS_NAME_REPLACEMENT = {
  inv: "Nota Fiscal",
  cnt: "Termo de Adesāo",
  pmCntPlDv: "Termo de Permanência Plano/Aparelho",
  id: "Documento Pessoal",
  crCardRt: "Cartão de Crédito",
  crCardRt2: "Cartão de Crédito 2",
  rePrf: "Comprovante de Residencia",
  oldUserId: "Documento Pessoal do Cedente",
  cntfacil: "Contrato Fácil",
  CLI_TECONTRACT: "Termo de Contratação",
  PED_TECONTRACT: "Termo de Contratação",
  CLI_SOCONTRACT: "Contrato Social",
  PED_SOCONTRACT: "Contrato Social",
  CLI_INVOICEOTH: "Fatura da Doadora",
  PED_INVOICEOTH: "Fatura da Doadora",
  CLI_PERMANENTC: "Contrato de Permanência",
  PED_PERMANENTC: "Contrato de Permanência",
  CLI_SERVICETER: "Termo ou Regulamento de Serviços",
  PED_SERVICETER: "Termo ou Regulamento de Serviços",
  CLI_ADMINATANO: "ATA de Nomeação dos Administradores",
  PED_ADMINATANO: "ATA de Nomeação dos Administradores",
  CLI_ATTORNEYLE: "Procuração",
  PED_ATTORNEYLE: "Procuração",
  CLI_MAILAUTHOR: "Autorização por e-mail do cliente para troca de aparelho",
  PED_MAILAUTHOR: "Autorização por e-mail do cliente para troca de aparelho",
  CLI_MAILSOLICI: "Termo de Autorização de Solicitação via e-mail",
  PED_MAILSOLICI: "Termo de Autorização de Solicitação via e-mail",
  CLI_BYLAWSCONS: "Estatuto Social Consolidado",
  PED_BYLAWSCONS: "Estatuto Social Consolidado",
  CLI_SHAREHOLDE: "ATA Assembléia Geral de Acionistas",
  PED_SHAREHOLDE: "ATA Assembléia Geral de Acionistas",
  CLI_EMPLOYEREQ: "Requerimento de Empresário",
  PED_EMPLOYEREQ: "Requerimento de Empresário",
  CLI_ADDRESSCOM: "Comprovante de Endereço",
  PED_ADDRESSCOM: "Comprovante de Endereço",
  CLI_CCMEICERTI: "CCMEI - Certifica da Condição de Microempreendedor Individual ou Alvará definitivo",
  PED_CCMEICERTI: "CCMEI - Certifica da Condição de Microempreendedor Individual ou Alvará definitivo",
  CLI_MEETINGEXT: "ATA da última reunião extraordinária do conselhor administrativo da Mitra Epscopal",
  PED_MEETINGEXT: "ATA da última reunião extraordinária do conselhor administrativo da Mitra Epscopal",
  CLI_ATOCONSTIT: "ATO Constitutivo do Cartório",
  PED_ATOCONSTIT: "ATO Constitutivo do Cartório",
  CLI_CCIRCERTIF: "Certificado de Cadastro de Imóvel Rural (CCIR)",
  PED_CCIRCERTIF: "Certificado de Cadastro de Imóvel Rural (CCIR)",
  CLI_ITRTAXOWNE: "Imposto sobre Propriedade Territorial Rural (ITR)",
  PED_ITRTAXOWNE: "Imposto sobre Propriedade Territorial Rural (ITR)",
  CLI_ATODELIBER: "ATO de Deliberação",
  PED_ATODELIBER: "ATO de Deliberação",
  CLI_TAXDOCUMEN: "Cartão de CNPJ com registro no Brasil",
  PED_TAXDOCUMEN: "Cartão de CNPJ com registro no Brasil",
  CLI_ATOEXTERIO: "ATO do poder executivo publicado no Diário Oficial ou emitido pelo Ministério das Relações Exteriores",
  PED_ATOEXTERIO: "ATO do poder executivo publicado no Diário Oficial ou emitido pelo Ministério das Relações Exteriores",
  CLI_ATOLIMITED: "ATO de Constituição de Sociedade Individual de Responsabilidade Limitada",
  PED_ATOLIMITED: "ATO de Constituição de Sociedade Individual de Responsabilidade Limitada",
  CLI_EIRELILTDA: "Última versão do Contrato Social da Empresa Limitada (Empresa que passou de Ltda para Eireli).",
  PED_EIRELILTDA: "Última versão do Contrato Social da Empresa Limitada (Empresa que passou de Ltda para Eireli).",
  CLI_EMAILACEPT: "E-mail de aceite do cliente",
  PED_EMAILACEPT: "E-mail de aceite do cliente",
  CLI_FTADOCUMEN: "FTA",
  PED_FTADOCUMEN: "FTA",
  CLI_CONDCOMNEG: "CONDIÇÕES COMERCIAIS DA NEGOCIAÇÃO",
  PED_CONDCOMNEG: "CONDIÇÕES COMERCIAIS DA NEGOCIAÇÃO",
  CLI_AUDIOCONFI: "Confirmação por Áudio",
  PED_AUDIOCONFI: "Confirmação por Áudio",
  CLI_PLACEPICTU: "Foto do Estabelecimento",
  PED_PLACEPICTU: "Foto do Estabelecimento",
  CLI_REPRPICTUR: "Foto do Representante Legal",
  PED_REPRPICTUR: "Foto do Representante Legal",
  CLI_ASSIGNPICT: "Assinatura",
  PED_ASSIGNPICT: "Assinatura",
  CLI_TERMADESAO: "Termo de Adesão",
  PED_TERMADESAO: "Termo de Adesão",
  CLI_CREDITDOCS: "Documentos Financeiros - Crédito",
  PED_CREDITDOCS: "Documentos Financeiros - Crédito",
  CLI_IDENTIFYID: "Documento de Identificação",
  PED_IDENTIFYID: "Documento de Identificação",
  CLI_ADDCONTRAC: "Termo de Adesão",
  PED_ADDCONTRAC: "Termo de Adesão",
  CLI_ATAREPRNOM: "Ata da eleição dos Diretores / Representantes Legais vigentes / Nomeação de Administrador",
  PED_ATAREPRNOM: "Ata da eleição dos Diretores / Representantes Legais vigentes / Nomeação de Administrador",
  CLI_ATASSEMBPU: "Ata da ultima assembléia arquiva na da Junta Comercial ou publicada no DO",
  PED_ATASSEMBPU: "Ata da ultima assembléia arquiva na da Junta Comercial ou publicada no DO",
  CLI_ATARQRCPJU: "Ata da ultima assembléia arquiva no Registro Civil de Pessoas Jurídica",
  PED_ATARQRCPJU: "Ata da ultima assembléia arquiva no Registro Civil de Pessoas Jurídica",
  CLI_ATAREPORGA: "Ata de posse dos representantes legais ou doc similar que conste do respresent do órgão",
  PED_ATAREPORGA: "Ata de posse dos representantes legais ou doc similar que conste do respresent do órgão",
  CLI_ATAPRECGOV: "Ata de Registro de Preço (Governo)",
  PED_ATAPRECGOV: "Ata de Registro de Preço (Governo)",
  CLI_IDENTITYID: "Carteira de Identidade",
  PED_IDENTITYID: "Carteira de Identidade",
  CLI_CIDEXCECAO: "CI de Exceção",
  PED_CIDEXCECAO: "CI de Exceção",
  CLI_RESIDCOMPR: "Comprovante de Residência",
  PED_RESIDCOMPR: "Comprovante de Residência",
  CLI_CONTCHANCJ: "Contrato Chancelado pelo Jurídico (TIM x Cliente)",
  PED_CONTCHANCJ: "Contrato Chancelado pelo Jurídico (TIM x Cliente)",
  CLI_CONTRACORP: "Contrato Corporativo",
  PED_CONTRACORP: "Contrato Corporativo",
  CLI_CONTRCUSTP: "Contrato Customizado (Elaborado pelo Jurídico)  - Privado ",
  PED_CONTRCUSTP: "Contrato Customizado (Elaborado pelo Jurídico)  - Privado ",
  CLI_COPIAEDITA: "Cópia do Edital",
  PED_COPIAEDITA: "Cópia do Edital",
  CLI_DOCCPORTIN: "Documentação Cedente / Portabilidade",
  PED_DOCCPORTIN: "Documentação Cedente / Portabilidade",
  CLI_EMAILJUCRE: "Email Análise / Aprovação Jurídico e Crédito",
  PED_EMAILJUCRE: "Email Análise / Aprovação Jurídico e Crédito",
  CLI_GARCONTRAT: "Garantia do Contrato",
  PED_GARCONTRAT: "Garantia do Contrato",
  CLI_OFIAUTCOMP: "Oficio ou empenho de autorização emitido pelo órgão competente*",
  PED_OFIAUTCOMP: "Oficio ou empenho de autorização emitido pelo órgão competente*",
  CLI_PDFSIMULAD: "Pdf Tarifas Aprovado (Simulador)",
  PED_PDFSIMULAD: "Pdf Tarifas Aprovado (Simulador)",
  CLI_PROJCOMASS: "Projeto Comercial assinado",
  PED_PROJCOMASS: "Projeto Comercial assinado",
  CLI_PUBOFICVEN: "Publicação Oficial ou emitida pelo órgão que confirme a ajudicação da TIM como vencedora",
  PED_PUBOFICVEN: "Publicação Oficial ou emitida pelo órgão que confirme a ajudicação da TIM como vencedora",
  CLI_ACEITEDIGI: "Termo de Aceite Digital",
  PED_ACEITEDIGI: "Termo de Aceite Digital",
  CLI_ACTCEDENTE: "Termo de Aceite Digital Cedente",
  PED_ACTCEDENTE: "Termo de Aceite Digital Cedente",
  CLI_TERMNOMADM: "Termo de Nomeação do Administrador de Contrato",
  PED_TERMNOMADM: "Termo de Nomeação do Administrador de Contrato",
  CLI_TERMPERMAN: "Termo de Permanência***",
  PED_TERMPERMAN: "Termo de Permanência***",
  CLI_TERPORTASS: "Termo de Portabilidade Preenchido e Assinado",
  PED_TERPORTASS: "Termo de Portabilidade Preenchido e Assinado",
  CLI_TERMTRANSF: "Termo de Transferência de Titularidade",
  PED_TERMTRANSF: "Termo de Transferência de Titularidade",
  CLI_TERMAUTCON: "Termo que autoriza a contratação direta sem licitação",
  PED_TERMAUTCON: "Termo que autoriza a contratação direta sem licitação",
  CLI_ULTALTCONT: "Última alteração contratual arquivada na Junta Comercial",
  PED_ULTALTCONT: "Última alteração contratual arquivada na Junta Comercial",
  CLI_ATODELINCOR: "Ato deliberativo da incorporadora aprovando a incorporação, registrado no órgão competente (Junta Comercial)",
  PED_ATODELINCOR: "Ato deliberativo da incorporadora aprovando a incorporação, registrado no órgão competente (Junta Comercial)",
  CLI_ATODELFUS : "Ato deliberativo das entidades fusionadas decidindo sobre a constituição definitiva da nova entidade, registrada no órgão competente (Junta Comercial)",
  PED_ATODELFUS : "Ato deliberativo das entidades fusionadas decidindo sobre a constituição definitiva da nova entidade, registrada no órgão competente (Junta Comercial)",
  CLI_AUTOSERV : "Autorização ou Ordem de Serviço",
  PED_AUTOSERV: "Autorização ou Ordem de Serviço",
  CLI_OUTRO: "OUTRO",
  PED_OUTRO: "OUTRO"
};

export const FILTER_CIRCLES_KEYS_NAME_REPLACEMENT = {
  QUANTITY: "Quantidade",
  RECEIPTVALUE: "Valor do Cartão de Crédito",
  AUTH: "Código de Autorização",
  CPF: "CPF",
  OMOTHERNAME: "Nome da mãe (fonte oficial)",
  OBIRTHDATE: "Data de Nascimento (fonte oficial)",
  BIRTHDATE: "Data de Nascimento",
  MOTHERNAME: "Nome da mãe",
  MONAME: "Nome da mãe",
  ONAME: "Nome (fonte oficial)",
  NAME: "Nome",
  VALIDITYDATE: "Data de Validade",
  RNE: "RNE",
  WEB: "Pacote Web",
  ID: "Número de Identidade",
  IDNUMBER: "Número de Identidade",
  TR_DATE: "Data da Transação",
  CADESTITLE: "Título do Termo de Adesão",
  CPERMTITLE: "Título do Termo de Permanência",
  MSISDN: "Número de Telefone",
  DISCOUNT: "Desconto",
  ORGEXP: "Órgão Expedidor",
  UF: "Unidade Federativa",
  EXP: "Data de Expedição",
  PH2: "Pacote Fase 2",
  FACE: "Foto da Identidade",
  SIMILARITY: "Biometria Facial",
  LIVELINESS: "Prova de Vida",
  OLDUSERNAME: "Usuário Antigo",
  PLACEOFBIRTH: "Local de Nascimento",
  NEWRG: "Novo RG",
  "SERIAL-DEVICE": "Número de Série"
};

export const PACKAGE_STATUS = {
  GREEN: "green",
  YELLOW: "yellow",
  RED: "red",
  TO: "TO",
  KO: "KO",
};

export const ALLOWED_UPDATE_PACKAGE_STATUS = [
  PACKAGE_STATUS.YELLOW
];

export const UNALLOWED_UPDATE_PACKAGE_ROLEIDS = [
  "mobile_capture"
];

export const FILTER_VALUES_NAME_REPLACEMENT = {
  [PACKAGE_STATUS.GREEN]: <span id="green_score" className={"dot green"} />,
  [PACKAGE_STATUS.YELLOW]: <span id="yellow_score" className={"dot yellow"} />,
  [PACKAGE_STATUS.RED]: <span id="red_score" className={"dot red"} />,
  [PACKAGE_STATUS.TO]: <span id="to_score" className={"dot"} />,
  [PACKAGE_STATUS.KO]: <span id="ko_score" className={"dot"} />,
};

export const CONSULT_API_MAX_PAGE_SIZE = 10000;